/**
 * Following code is a copy from 'flat' library (v5.0.2): @see https://github.com/hughsk/flat.
 * The modifications performed by us is neglible, and is only confined to TS support and ESLint compliance.
 * Note: we haven't reviewed the code to avoid spending time rewriting it.
 *
 * @param obj the object to be checked as buffer type.
 * @returns boolean outcome
 */
export var isBuffer = function (obj) {
    return obj && obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};
export var keyIdentity = function (key) { return key; };
//# sourceMappingURL=flatUtils.js.map